/**
 * Initialize Swiper sliders for impact stats blocks
 */

/* global Swiper */

document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelectorAll('.stats-slider').length) {
    return;
  }


  // Initialize image sliders
  const blockSliders = document.querySelectorAll(
    '.stats-slider[data-slider-type="block"]'
  );

  /** Theme `$desktop_width` — multi-slide swiper from here when 5+ slides */
  // eslint-disable-next-line no-unused-vars -- reserved for future breakpoint parity with SCSS
  const STATS_DESKTOP_MIN = 1024;
  /** Swiper min-width breakpoints: carousel below 768px; static row from 768px up (<5 slides) */
  const STATS_STATIC_ROW_BREAKPOINT = 768;

  blockSliders.forEach((slider, index) => {
    const sliderId = `impact-stats-slider-${index}`;
    slider.id = sliderId;
    const slideCount = slider.querySelectorAll('.stat-card').length;

    const spv = (n) => Math.max(1, Math.min(n, slideCount));
    const canLoop = slideCount > 1;
    const useDesktopSlider = slideCount >= 5;
    // Loop clones break the static row; rewind when <5 slides while the carousel is active
    const useRewind = !useDesktopSlider && canLoop;
    // One card per view while carousel runs (viewport under 768px for <5 slides)
    const slidesPerViewCarousel = 1;

    if (!useDesktopSlider) {
      slider.classList.add('stats-slider--static-row');
    }

    const breakpoints = useDesktopSlider
      ? {
          768: {
            slidesPerView: spv(slideCount > 3 ? 3 : slideCount - 1),
            spaceBetween: 24,
          },
          1300: {
            slidesPerView: spv(slideCount >= 4 ? 4 : slideCount - 1),
            spaceBetween: 45,
          },
          1600: {
            slidesPerView: spv(slideCount > 5 ? 5 : slideCount - 1),
            spaceBetween: 45,
          },
        }
      : {
          [STATS_STATIC_ROW_BREAKPOINT]: {
            enabled: false,
          },
        };

    // Initialize Swiper
    new Swiper(`#${sliderId}`, {
      slidesPerView: useDesktopSlider
        ? spv(slideCount > 3 ? 3 : slideCount - 1)
        : slidesPerViewCarousel,
      slidesPerGroup: 1,
      spaceBetween: 12,
      initialSlide: 0,
      // centeredSlides + loop/rewind with few slides causes wrong index and visible gaps
      centeredSlides: false,
      loop: useDesktopSlider && canLoop,
      rewind: useRewind,
      watchSlidesProgress: useDesktopSlider && canLoop,
      pagination: {
        el: `#${sliderId} .swiper-pagination`,
        type: 'bullets',
        clickable: true,
      },
      autoplay: canLoop
        ? {
            delay: 5000,
            disableOnInteraction: false,
          }
        : false,
      breakpoints,
    });
  });
});
